import { useState } from "react";
import { toast } from "react-toastify";
import { Button, FullScreenLoading, TextInput } from "src/Components";
import { IUpdateDeltaHedgeTargetDto } from "src/Interfaces/deltaHedgeOrder";
import { StepOrderSide } from "src/Interfaces/stepInterfaces";
import { updateTarget } from "src/Requests/deltaHedgeOrder";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface Props {
  onClose: () => void;
  onAction: () => void;
  initialValues: IUpdateDeltaHedgeTargetDto;
  instrumentNames: string[];
  orderTypeStr: string;
}
const UpdateTarget: React.FC<Props> = ({
  onClose,
  initialValues,
  instrumentNames,
  orderTypeStr,
  onAction,
}) => {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] =
    useState<IUpdateDeltaHedgeTargetDto>(initialValues);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const onSendClick = () => {
    setLoading(true);
    updateTarget({
      ...formValues,
      newLockProfitTarget: formValues.newLockProfitTarget
        ? Number(formValues.newLockProfitTarget)
        : (null as any),
    })
      .then((resp) => {
        toast.success(resp.msg);
        onAction();
        onClose();
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const checkIsBtnDisabled = () => {
    if (!formValues.newLockProfitTarget) return true;
    return false;
  };

  return (
    <div className="flex flex-col justify-start items-start gap-[6px] whitespace-nowrap text-xs ml-2 border-2 border-gray-300 rounded py-3 px-2 mt-6">
      {loading ? <FullScreenLoading /> : <></>}

      <div className="grid grid-cols-2 gap-3 font-bold">
        <div className="flex flex-row justify-start items-center gap-2">
          <div>فرایند:</div>
          <div>{orderTypeStr}</div>
        </div>
        <div />
        <div className="flex flex-row justify-start items-center gap-2">
          <div>نماد اول:</div>
          <div
            className={`${
              formValues.orderSide1 === StepOrderSide.Buy
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {instrumentNames?.[0]}
          </div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>جهت اول:</div>
          <div
            className={`${
              formValues.orderSide1 === StepOrderSide.Buy
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {formValues.orderSide1 === StepOrderSide.Buy ? "خرید" : "فروش"}
          </div>
        </div>

        <div className="flex flex-row justify-start items-center gap-2">
          <div>نماد دوم:</div>
          <div
            className={`${
              formValues.orderSide2 === StepOrderSide.Buy
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {instrumentNames?.[1]}
          </div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>جهت دوم:</div>
          <div
            className={`${
              formValues.orderSide2 === StepOrderSide.Buy
                ? "text-green-700"
                : "text-red-700"
            }`}
          >
            {formValues.orderSide2 === StepOrderSide.Buy ? "خرید" : "فروش"}
          </div>
        </div>

        <TextInput
          label="معیار"
          name="newLockProfitTarget"
          value={formValues.newLockProfitTarget?.toString()}
          onChange={changeHandler}
          classname="ltr !text-right"
        />
      </div>

      <div className="flex flex-row justify-between items-center w-full mt-2">
        <Button
          onClick={onClose}
          text="لغو"
          variant="outlined"
          className="!w-16 !h-6 !text-xs"
        />
        <Button
          onClick={onSendClick}
          text="ارسال"
          variant="contained"
          className="!w-16 !h-6 !text-xs"
          disabled={checkIsBtnDisabled()}
        />
      </div>
    </div>
  );
};

export default UpdateTarget;
